export default {
    /* GET_PAPER_GROUPS
    ---------------------------------------------------------------
    */
    GET_PAPER_GROUPS_REQUEST: state => {
        state.paperGroupsLoading = true
    },
    GET_PAPER_GROUPS_SUCCESS: (state, data) => {
        state.paperGroups = data.results
        state.paperGroupsLoading = false
    },
    GET_PAPER_GROUPS_FAILURE: state => {
        state.paperGroupsLoading = false
    },
    SET_PAPER_GROUPS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PAPER_GROUPS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}